import { render, staticRenderFns } from "./ESGScopeConversionTemp.vue?vue&type=template&id=f0ca1162"
import script from "./ESGScopeConversionTemp.vue?vue&type=script&lang=js"
export * from "./ESGScopeConversionTemp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports